import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TenantInvitation, TenantInvitationCreate, TenantInvitationFilter } from '../data/tenantInvitation';

export function createTenantInvitationService(client: AxiosInstance) {
  return createCrudService<TenantInvitation, TenantInvitationCreate, TenantInvitationFilter>(
    client,
    '/tenancy/TenantInvitation',
    'id',
  );
}

export type TenantInvitationService = CrudService<TenantInvitation, TenantInvitationCreate, TenantInvitationFilter>;
